export default {"src":"/_next/static/media/mingcute_paper-line.6734110f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};